import { Empty, Tabs, Popover, Pagination } from 'antd';
import BannerWithImage from 'components/BannerWithImage';
import CalendarAsc from 'components/Icons/CalendarAsc';
import CalendarDesc from 'components/Icons/CalendarDesc';
import { I18nt } from 'utils';
import styles from './HistorialCitas.module.less';
import { FilterFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import CitaBox from '../components/CitaBox';
import { useHistorialCitas } from '../HistorialCitasContext';
import { paths } from '../../../config/index';
import { useCallback, useEffect } from 'react';

const ResultsView = () => {
  const {
    filteredProximasCitas,
    filteredPreviasCitas,
    filterBy,
    setFilterBy,
    dispatch,
    setPagePrevias,
    setPageProximas,
    perPage,
    pagePrevias,
    pageProximas,
    sort,
    nombrePaciente
  } = useHistorialCitas();

  const handlePreviasPageClick = (page: number) => {
    setPagePrevias(page - 1);
  };


  const handleProximasPageClick = (page: number) => {
    setPageProximas(page - 1);
  };

  const [citasPrevias, totalCitasPrevias] = filteredPreviasCitas;
  const [citasProximas, totalCitasProximas] = filteredProximasCitas;

  useEffect(() => {
    dispatch({
      type: 'sortCitas',
      payload: 'desc',
    });
  }, []);

  const handleSortClick = () => {
    const sortDirection = sort === 'desc' ? 'asc' : 'desc';
    dispatch({
      type: 'sortCitas',
      payload: sortDirection,
    });
  };

  const proximasCitasMap = useCallback(() => {
    if (citasProximas.length === 0) {
      return (
        <div className={styles.emptyProximasCitas}>
          <Empty description={I18nt('no_tienes_citas_programadas')} />
          <Link to={paths.agendar_cita}>{I18nt('calendarizar_cita')}</Link>
        </div>
      );
    }

    return (<>
      {citasProximas.map((cita) => (
        <CitaBox cita={cita} key={cita.idCita} isCancelVisible />
      ))};
      <Pagination
        className={styles.pagination}
        total={totalCitasProximas}
        pageSize={perPage}
        current={pageProximas + 1}
        onChange={handleProximasPageClick}
      />
    </>);
  }, [filteredProximasCitas]);

  const previasCitasMap = useCallback(() => {
    if (citasPrevias.length === 0) {
      return (
        <div className={styles.emptyProximasCitas}>
          <Empty description={I18nt('no_tienes_citas_historial')} />;
        </div>
      );
    }

    return (<>
      {citasPrevias.map((cita) => (
        <CitaBox cita={cita} key={cita.idCita} />
      ))}
      <Pagination
        className={styles.pagination}
        total={totalCitasPrevias}
        pageSize={perPage}
        current={pagePrevias + 1}
        onChange={handlePreviasPageClick}
      />
    </>);
  }, [filteredPreviasCitas]);

  const filterContent = () => (
    <div className={styles.filterContent}>
      <button
        className={filterBy === 'general' ? styles.btnActive : ''}
        onClick={() => setFilterBy('general')}
      >
        {I18nt('general')}
      </button>
      <button
        className={filterBy === 'especialista' ? styles.btnActive : ''}
        onClick={() => setFilterBy('especialista')}
      >
        {I18nt('especialista')}
      </button>
      {filterBy ? (
        <button onClick={() => setFilterBy(null)}>{I18nt('limpiar')}</button>
      ) : null}
    </div>
  );

  return (
    <BannerWithImage className={styles.resultsView}>
      <div className={styles.resultsWrapper}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h4>{I18nt('mis_citas')}</h4>
            <p>{I18nt('aqui_puedes_consultar_citas')}</p>
            <p className={styles.paciente}>
              <span>{`${I18nt('paciente')}: `}</span>
              {nombrePaciente}
            </p>
          </div>
          <div className={styles.headerActions}>
            <Popover
              placement='bottomLeft'
              title={I18nt('filtrar')}
              content={filterContent()}
              trigger='click'
            >
              <div className={styles.actionButton}>
                <FilterFilled />
                <p>{I18nt('filtrar')}</p>
              </div>
            </Popover>
            <div className={styles.actionButton} onClick={handleSortClick}>
              {sort === 'desc' ? <CalendarAsc /> : <CalendarDesc />}
              <p>{I18nt('ordenar')}</p>
            </div>
          </div>
        </div>
        <div className={styles.citasList}>
          <Tabs defaultActiveKey='1'>
            <Tabs.TabPane tab={I18nt('proximas_citas')} key='1'>
              {proximasCitasMap()}
            </Tabs.TabPane>
            <Tabs.TabPane tab={I18nt('citas_anteriores')} key='2'>
              {previasCitasMap()}
            </Tabs.TabPane>
          </Tabs>
        </div>
      </div>
    </BannerWithImage>
  );
};

export default ResultsView;
